module.exports = __webpack_public_path__ + "static/media/shelter_anchorage_1.0e8f09f9.svg";